import { Icon, SearchBox, Spinner, SpinnerSize } from '@fluentui/react';
import { Utils } from '../../../common/views/Utils';
import { CustomerFilterType, ShortCustomerModel } from '../../models/CustomerModel';

import { Page } from '../../../grid/models/Page';
import { Pager } from '../../../grid/views/Pager';
import { useCustomerAdminVM } from '../../viewmodels/CustomerAdminVM';
import { useEffect, useRef } from 'react';
import CustomerGridView from './CustomerGridView';
import MenuPicker from '../../../common/views/MenuPicker';

type CustomerProps = {
    onSelect?: (customer: ShortCustomerModel) => void;
}

export default function CustomerView({ onSelect }: CustomerProps) {
    const hasLoaded = useRef(false);
    const vm = useCustomerAdminVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.onLoad();
    }, [vm]);

    const onTypeChange = (type: CustomerFilterType) => {
        vm.filter.filterType = type;
        vm.filter.pageNumber = 1;
        vm.getList(false, false);
    }

    const headerElement = () => {
        const width3 = Utils.getColumnWidth(3);
        const width9 = Utils.getColumnWidth(9);

        return <>
            <div className="ms-Grid-row pb-10">
                <div className={width9}>
                    <SearchBox
                        autoFocus={false}
                        value={vm.filter.search}
                        placeholder="Search"
                        onChange={(_, newValue) => vm.setFilterField("search", newValue || "")}
                        onSearch={(value: string) => vm.getList(true, false)}
                        className="searchbox"
                        styles={{ root: { width: "100%" } }}
                    />
                </div>
                <div className={width3 + " container right"}>
                    <div className="pr-10">
                        <Icon
                            iconName="Refresh"
                            onClick={() => vm.getList(false, false)}
                            className="icon"
                        />
                    </div>

                    <MenuPicker
                        options={vm.types}
                        setOptions={vm.setTypes}
                        onChange={onTypeChange}
                    />
                </div>
            </div>
        </>;
    }

    const onPageChange = (page: Page) => {
        if (page) {
            vm.filter.pageNumber = page.pageNumber;
            if (vm.filter.pageSize !== page.pageSize) vm.filter.pageNumber = 1;
            vm.filter.pageSize = page.pageSize;

            vm.getList(false, true);
        }
    }

    return <div className="ms-Grid">
        {headerElement()}

        <div className="ms-Grid-row pt-10">
            {vm.loading && <Spinner size={SpinnerSize.large} />}

            <CustomerGridView
                customers={vm.customers}
                key={vm.listHash}
                filterType={vm.filter.filterType}
                onSelect={(customer: ShortCustomerModel) => {
                    if (onSelect) onSelect(customer);
                }} />
        </div>

        <div className="ms-Grid-row">
            <Pager
                totalCount={vm.totalCount}
                onChange={onPageChange}
                pageSize={vm.filter.pageSize}
                hideGoTop={true}
                key={vm.pageHash} />
        </div>
    </div>;
}